<template>
    <div class="reviews__list uk-child-width-1-2@m uk-grid-small" uk-grid uk-height-match target=".uk-comment" data-uk-rr-grid-results>
        <div v-for="item in items">
            <article class="review uk-comment uk-position-relative">
                <div class="review__badge uk-position-top-right" v-if="item.status === 'accepted'">
                    <i class="fal fa-check-circle uk-text-success" :title="$t('rubinred.ecommerce.core.common.reviews.accepted')"></i>
                </div>
                <div class="review__badge uk-position-top-right" v-else>
                    <i class="fal fa-exclamation-circle uk-text-warning" :title="$t('rubinred.ecommerce.core.common.reviews.not_accepted')"></i>
                </div>
                <header class="review__header uk-comment-header uk-grid-small uk-flex-middle" uk-grid>
                    <div class="review__avatar uk-width-auto" v-if="item.reviewable.featured_media">
                        <a :href="item.reviewable.link"><img class="uk-comment-avatar" :src="item.reviewable.featured_media"></a>
                    </div>
                    <div class="review__title-wrapper uk-width-expand">
                        <h4 class="review__title uk-comment-title uk-margin-remove">
                            <a :href="item.reviewable.link" class="uk-link-reset">{{item.reviewable.name}}</a>
                        </h4>
                        <ul class="review__meta uk-comment-meta uk-subnav uk-subnav-divider uk-margin-remove-top">
                            <li>
                                {{item.created_at.diff}}
                            </li>
                            <li v-html="item.rating"></li>
                        </ul>
                    </div>
                </header>
                <div class="review__body uk-comment-body">
                    <h5 class="uk-margin-remove">{{item.title}}</h5>
                    <p class="uk-margin-remove">{{item.comment}}</p>
                </div>
            </article>
        </div>
    </div>
</template>
<script>
  import DataGridResults from 'js/theme-mixins/DataGridResults';

  export default {
    mixins: [DataGridResults],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/grid/ReviewsDataGridResults.vue